module.exports = __webpack_public_path__ + "static/img/产品界面图_03@2x.d54311ff.png";